import { render, staticRenderFns } from "./CardStyle6.vue?vue&type=template&id=5f13513e&scoped=true&"
import script from "./CardStyle6.vue?vue&type=script&lang=js&"
export * from "./CardStyle6.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle6.vue?vue&type=style&index=0&id=5f13513e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13513e",
  null
  
)

export default component.exports